<template>
  <div class="doctor-reward-statistics">
    <div class="page_title">敏感词库</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="moduleName">
          <el-tab-pane
            label="敏感词库"
            name="1"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1801') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="敏感词拦截规则"
            name="2"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1806') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="敏感词拦截记录"
            name="3"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1807') : false
            "
          ></el-tab-pane>
        </el-tabs>

        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import SensitiveKeywordsList from "./components/SensitiveKeywordsList.vue";
import SensitiveKeywordsRuleList from "./components/SensitiveKeywordsRuleList.vue";
import SensitiveKeywordsLogList from "./components/SensitiveKeywordsLogList.vue";
export default {
  data() {
    return {
      moduleName: "1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.moduleName) {
        case "1":
          return SensitiveKeywordsList;
        case "2":
          return SensitiveKeywordsRuleList;
        case "3":
          return SensitiveKeywordsLogList;
      }
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
